import * as Colors from "../../../../../environment/globalStyles/administratorColors";

export const cardStyle = {
    backgroundColor: Colors.primary,
    color: "white",
    cursor: "pointer"
};
